<!-- 新闻详情 -->
<template>
<div class='cm_news_detail_container'>
  <div :class="mobileClass('cm_news_detail_box')" v-loading="loading" >
      <span>您的位置：{{name}} </span>
      <div class="cm_new_detail_title">
        <h3>{{content.TITLE}}</h3>
        <span>来源：{{content.SOURCE}}　　发布时间：{{content.PUBLISH_DATE}}</span>
      </div>
      <div class="cm_new_detail_line">
        <div class="cm_new_detail_content" v-html="content.CONTENT" id="printPage" style="font-size: 16px!important;font-family: 'Helvetica Neue',Helvetica,'PingFang SC','Hiragino Sans GB','Microsoft YaHei','微软雅黑',Arial,sans-serif;!important"></div>
        <div v-if="content.FILE0" class="cm_news_detail_fj">
          附件：<span>{{content.TITLE}}</span><a :href="baseUrl+content.FILE0">点击下载</a>
        </div>
      </div>
      <div>
        <div class="cm_new_detil_other">
          <div><span class="cm_font_blue" v-if="preData">上一篇：</span><router-link v-if="preData" :to="{path:this.preData?'/detail/'+this.preData.NEWS_ID:'',query: {parentData:JSON.stringify(data)}}">{{this.preData?this.preData.TITLE:"没有了"}}</router-link></div>
          <a href="javascript:void(0);" @click="printpage()" class="cm_bottom_button">【打印本页】</a>
         
        </div>
        <div class="cm_new_detil_other">
          <div><span class="cm_font_blue" v-if="nextData">下一篇：</span><router-link v-if="nextData" :to="{path:this.nextData?'/detail/'+this.nextData.NEWS_ID:'',query: {parentData:JSON.stringify(data)}}">{{this.nextData?this.nextData.TITLE:"没有了"}}</router-link></div>
          <router-link :to="{path:'/'}" class="cm_bottom_button">【关闭本页】</router-link>
         </div>
      </div>
  </div>
  <iframe src="" frameborder="0" id="print-iframe"></iframe>
</div>
</template>

<script>

export default {
components: {},
data() {
//这里存放数据
return {
  id:this.$route.params.newsId,
  data:JSON.parse(this.$route.query.parentData).data?JSON.parse(this.$route.query.parentData).data:JSON.parse(this.$route.query.parentData),
  name:JSON.parse(this.$route.query.parentData).title?JSON.parse(this.$route.query.parentData).title:JSON.parse(this.$route.query.parentData).name, 
  content:"",
  dataList:[],
  sort:"",
  listCount:"",
  preData:{},
  nextData:{},
  baseUrl:window.SITE_CONFIG.baseUrl,
  windowWidth:document.documentElement.clientWidth,
  loading:true
};
},
//监听属性 类似于data概念
computed: {
  mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
},
//监控data中的数据变化
watch: {
  '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  },
  '$route': function (to, from) {
    this.id=this.$route.params.newsId,
    this.data=JSON.parse(this.$route.query.parentData),
    this.httpPost()
    this.httpUrlPost()
  }
},
//方法集合
methods: {
  toDetail(ID,data){
      this.$router.push({path:'/detail/'+ID,query: {parentData:data}})
    },
  httpPost() {
      let newsId = this.id
      this.loading = true
      this.$http({
        url: this.$http.adornUrl('requestMainMobile/pageService/newsDetail'),
        method: 'post',
        data: {'newsId':newsId}
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.content = data.data.data
          this.loading = false
        }
          
      });
    },
  httpUrlPost() {
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data
      }).then(({ data }) => {

        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.sort = this.checkList()
          this.checkCount()
        }
          
      });
    },
    printpage() {
          var el = document.getElementById('printPage').innerHTML;
          var iframe = document.getElementById('print-iframe')
          var doc = iframe.contentWindow.document;
          doc.write(el);
          doc.close();
          iframe.onload = function () {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }
        },
    checkList(){
      let list = this.dataList
      for(let i=0;i<list.length;i++){
        if(list[i].NEWS_ID === this.id){
          return i
        }
      }
    },
    checkCount(){
      this.listCount = this.data.showCount?this.data.showCount:"15"
      if(0<this.sort<this.listCount ){
        this.preData=this.dataList[this.sort - 1]
        this.nextData=this.dataList[this.sort + 1]
        // console.log(this.preData,this.nextData)
      }
      else if(this.sort == 0&&this.dataList.currentPage>1){
        this.data.currentPage = this.dataList.currentPage-1
        this.httpUrlPost()
      }
      else if(this.sort == this.listCount && this.dataList.currentPage != this.dataList.totalPage){
          this.data.currentPage = this.dataList.currentPage+1
          this.httpUrlPost()
      }
      
    }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  this.httpPost()
  this.httpUrlPost()
},

}
</script>
<style>
#print-iframe{
  position:absolute;
  width:0px;
  height:0px;
  left:-500px;
  top:-500px;
}
.cm_news_detail_container{
  margin: 20px 0;
  width:100%;
  display:flex;
  justify-content: center;
}
.cm_news_detail_box{
  width: 1200px;
  min-height: 550px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 20px;
}
.cm_news_detail_box>span{
  width: 100%;
  display:flex;
  justify-content: flex-end;
}
.cm_new_detail_title{
  border-bottom: 1px solid #4379D3;
}
.cm_news_detail_fj{
  margin-bottom: 20px;
  margin-left: 20px;
}
.cm_news_detail_fj>a{
  color: #4379D3;
}
.cm_new_detail_title>h3{
  width:100%;
  font-size: 24px;
  font-weight: bold;
  color: #4379D3;
  display:flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.cm_new_detail_title>span{
  width:100%;
  font-size: 14px;
  font-weight: 400;
  color: #A6A6A6;
  display:flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}
.cm_bottom_button{
  width: 120px;
  display: flex;
  justify-content: flex-end;
}
.cm_new_detail_content{
  padding: 40px 0;
  min-height: 300px;
  overflow: hidden;
}
.cm_new_detail_line{
  border-bottom: 1px solid #4379D3;
}
.cm_font_blue{
  font-size: 16px;
  color: #4379D3;
}
.cm_new_detil_other{
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.mobile_cm_news_detail_box{
  width: 100%;
  min-height: 550px;
  background: #FFFFFF;
  border: 1px solid #E1E4E7;
  padding: 20px;
}
.mobile_cm_news_detail_box img{
  max-width: 100%;
}
.mobile_cm_news_detail_box>span{
  width: 100%;
  display:flex;
  justify-content: flex-end;
  font-size: 16px;
}
</style>